import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Form,
  Button,
  Card,
  Badge,
  Alert,
  InputGroup,
  ProgressBar,
  Spinner,
  OverlayTrigger,
  Tooltip,
  ButtonGroup,
  Accordion,
  Table
} from "react-bootstrap";
import "../componentCss/webform.css";
import "../componentCss/sidebar.css";
import "../componentCss/healthcare-modern.css";
import toast, { Toaster } from 'react-hot-toast';
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import config from "../../config/config";
import {
  AiOutlineCalendar,
  AiOutlineUser,
  AiOutlineSearch,
  AiOutlineClear,
  AiOutlineFilter
} from "react-icons/ai";
import {
  getStaffListAction,
  getStaffDetailsAction,
  getFormListWithPermissionAction,
  updateFormsPermissionAction,
  getPatientListAction,
  assignPatientAction,
  getAssignedPatientListAction,
  updateStaffStatusAction,
  getSchedulesAction
} from "../../Action/modernAdminActions";
import Swal from "sweetalert2";

import ReactToPrint, { useReactToPrint } from "react-to-print";
import {
  MdEdit,
  MdPeople,
  MdSchedule,
  MdFilterList,
  MdRefresh,
  MdInfo,
  MdWarning,
  MdCheckCircle,
  MdCancel
} from "react-icons/md";
import {
  FaEye,
  FaCalendarAlt,
  FaUsers,
  FaUserCog,
  FaSearch,
  FaFilter,
  FaCheck,
  FaTimes,
  FaUserShield,
  FaClipboardList,
  FaCheckSquare
} from "react-icons/fa";
import {
  BsPersonAdd,
  BsCalendar2Week,
  BsPersonCheck,
  BsPersonX,
  BsSearch,
  BsFilter,
  BsInfoCircle,
  BsCheckSquare,
  BsSquare,
  BsEyeFill,
  BsGear
} from "react-icons/bs";
import { IoPerson, IoPrintSharp, IoCalendar, IoSettings } from "react-icons/io5";
import { decryptData } from './decrypt';
import { BsToggleOn, BsToggleOff } from "react-icons/bs";

const DutySchedule = () => {
  // Core state
  const [staffList, setStaffList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Modal states
  const [isModelOpen, setIsOpen] = useState(false);
  const [isModelView, setIsModelView] = useState(false);
  const [viewData, setViewData] = useState({});

  // Current editing staff
  const [staffId, setStaffId] = useState(0);
  const [currentStaffName, setCurrentStaffName] = useState('');
  const [isLaoding, setisLaoding] = useState(0);

  // Enhanced filter and search state
  const [details, setDetails] = useState({
    fromDate: '',
    toDate: '',
    status: 'all',
    name: '',
    department: '',
    role: ''
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [filterBy, setFilterBy] = useState('all'); // all, active, inactive
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  // Pagination and display state
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Enhanced UI state
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [showBulkActions, setShowBulkActions] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    onDuty: 0,
    withPermissions: 0
  });
  const [updateProgress, setUpdateProgress] = useState(0);
  const [hasFiltersApplied, setHasFiltersApplied] = useState(false);

  // Refs
  const allDataRef = useRef();
  const singleRowRef = useRef();

  // Enhanced helper functions
  const handlePageChange = (page) => {
    setCurrentPage(page - 1);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };

  const calculateStats = () => {
    const total = staffList.length;
    const active = staffList.filter(staff => staff.is_active).length;
    const onDuty = staffList.filter(staff => staff.status === 'active').length;
    const withPermissions = staffList.filter(staff => staff.roles && staff.roles.length > 0).length;

    setStats({ total, active, onDuty, withPermissions });
  };

  const checkFiltersApplied = () => {
    const hasFilters = details.fromDate || details.toDate || details.name ||
      details.department || details.role || filterBy !== 'all' || searchTerm;
    setHasFiltersApplied(hasFilters);
  };

  const resetAllFilters = () => {
    setDetails({ fromDate: '', toDate: '', status: 'all', name: '', department: '', role: '' });
    setSearchTerm('');
    setFilterBy('all');
    setShowAdvancedFilters(false);
    setHasFiltersApplied(false);
    // Reload data
    setTimeout(() => getStaffListAPI(), 100);
  };

  const getStatusBadge = (status) => {
    if (status === 'active' || status === true) {
      return (
        <span className="healthcare-status-badge healthcare-status-active" style={{
          backgroundColor: '#dcfce7',
          color: '#166534',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.75rem',
          fontWeight: '500'
        }}>
          ACTIVE
        </span>
      );
    } else {
      return (
        <span className="healthcare-status-badge healthcare-status-inactive" style={{
          backgroundColor: '#f1f5f9',
          color: '#64748b',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '0.75rem',
          fontWeight: '500'
        }}>
          INACTIVE
        </span>
      );
    }
  };
  useEffect(() => {
    getStaffListAPI();
  }, []);

  useEffect(() => {
    setSelectedRow(null);
  }, [currentPage]);

  useEffect(() => {
    calculateStats();
  }, [staffList]);

  useEffect(() => {
    checkFiltersApplied();
  }, [details, filterBy, searchTerm]);


  const handleOpenEditView = (id, staffName = '') => {
    setStaffId(id);
    setCurrentStaffName(staffName);
    getFormListAPI(id);
  };

  const handleViewClose = () => {
    setIsModelView(false);
    setViewData({});
    setFormList([]);
  };

  const handleOpenView = (data) => {
    setViewData(data);
    const staffName = data.full_name || `${data.first_name || ''} ${data.last_name || ''}`.trim();
    setCurrentStaffName(staffName);
    setIsModelView(true);
    handleOpenEditView(data.id, staffName);
  };


  let getFormListAPI = async (userId) => {
    try {
      let res = await getFormListWithPermissionAction({ userId: userId });
      if (res.success) {
        // Modern API returns data directly without encryption
        setFormList(Array.isArray(res.data) ? res.data : []);
      } else {
        setFormList([]);
        toast.error(res.message || "Failed to load form permissions");
      }
    } catch (error) {
      setFormList([]);
      toast.error("An error occurred while loading form permissions");
    }
  };

  let getStaffListAPI = async () => {

    if (details.fromDate && !details.toDate) {
      toast.error('Please select to date');
      return
    }

    if (!details.fromDate && details.toDate) {
      toast.error('Please select from date');
      return
    }

    setIsLoading(true);
    try {
      let res = await getStaffListAction(details);
      setIsLoading(false);
      if (res.success) {
        // Modern API returns data directly without encryption
        setStaffList(Array.isArray(res.data) ? res.data : []);
      } else {
        setStaffList([]);
        toast.error(res.message || "Failed to load staff list");
      }
    } catch (error) {
      setIsLoading(false);
      setStaffList([]);
      toast.error("An error occurred while loading the staff list");
    }
  };

  const getStaffListAPIForFilter = async () => {
    // Instead of reloading the page, reset filters and fetch fresh data
    resetAllFilters();
  };


  let handleChange = (permissionType, formId) => {
    setFormList((prevForms) => {
      return prevForms.map((form) => {
        if (form.id === formId) {
          if (permissionType == "isAccess") {
            return {
              ...form,
              isAccess: !form.isAccess,
            };
          } else if (permissionType == "isEdit") {
            return {
              ...form,
              isEdit: !form.isEdit,
            };
          } else if (permissionType == "isDelete") {
            return {
              ...form,
              isDelete: !form.isDelete,
            };
          }
        }
        return form;
      });
    });
  };


  let submitPermissionForm = async (e) => {
    e.preventDefault();
    setisLaoding(1);
    let res = await updateFormsPermissionAction({
      userId: staffId,
      formsPermission: formList,
    });
    if (res.success) {
      toast.success(res.msg);
      setTimeout(() => {
        setisLaoding(0);
        setIsOpen(false);
      }, 2000);
    } else {
      toast.error(res.msg);
    }
  };


  const searchByNameHandler = (e) => {
    const { name, value } = e.target;
    setDetails((old) => ({
      ...old,
      [name]: value
    }));
  };

  const filteredFormList = formList.filter((data) =>
    (data.name && data.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (data.departmentName && data.departmentName.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const filteredStaffList = staffList.filter((staff) => {
    const matchesSearch = !searchTerm ||
      (staff.full_name && staff.full_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (staff.first_name && staff.first_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (staff.last_name && staff.last_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (staff.email && staff.email.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesFilter = filterBy === 'all' ||
      (filterBy === 'active' && staff.is_active) ||
      (filterBy === 'inactive' && !staff.is_active);

    return matchesSearch && matchesFilter;
  });





  const handleClose = () => {
    setIsOpen(false);
    setFormList([]);
    setStaffId(0);
    setCurrentStaffName('');
  };

  const handleOpen = (id, staffName = '') => {
    setStaffId(id);
    setCurrentStaffName(staffName);
    getFormListAPI(id);
    setIsOpen(true);
  };

  const handleStaffSelection = (staffId) => {
    setSelectedStaff(prev => {
      const newSelection = prev.includes(staffId)
        ? prev.filter(id => id !== staffId)
        : [...prev, staffId];
      setShowBulkActions(newSelection.length > 0);
      return newSelection;
    });
  };



  const columns = [
    {
      name: (
        <Form.Check
          type="checkbox"
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedStaff(filteredStaffList.map(staff => staff.id));
              setShowBulkActions(true);
            } else {
              setSelectedStaff([]);
              setShowBulkActions(false);
            }
          }}
          checked={selectedStaff.length === filteredStaffList.length && filteredStaffList.length > 0}
        />
      ),
      cell: (row) => (
        <Form.Check
          type="checkbox"
          checked={selectedStaff.includes(row.id)}
          onChange={() => handleStaffSelection(row.id)}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "50px"
    },
    {
      name: "#",
      cell: (row, index) => {
        return index + 1 + currentPage * rowsPerPage;
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px"
    },
    {
      name: "Staff Details",
      cell: (row) => {
        const fullName = row.full_name || `${row.first_name || ''} ${row.last_name || ''}`.trim();
        return (
          <div className="d-flex align-items-center">
            <div className="me-3">
              <div className="rounded-circle bg-primary d-flex align-items-center justify-content-center" style={{ width: '45px', height: '45px' }}>
                <IoPerson size={22} className="text-white" />
              </div>
            </div>
            <div>
              <div className="fw-bold">{fullName}</div>
              <small className="text-muted d-block">{row.email}</small>
              <div className="mt-1 d-flex align-items-center gap-1">
                {getStatusBadge(row.is_active ? 'active' : 'inactive')}
                {row.employee_id && (
                  <Badge bg="light" text="dark" className="ms-1">
                    ID: {row.employee_id}
                  </Badge>
                )}
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "28%"
    },
    {
      name: "Department & Role",
      cell: (row) => (
        <div>
          <div className="fw-bold d-flex align-items-center">
            <MdPeople size={16} className="me-2" style={{ color: '#64748b' }} />
            {row.department_name || row.department || (
              <span style={{ color: '#9ca3af' }}>Not Assigned</span>
            )}
          </div>
          <small className="text-muted d-flex align-items-center">
            <FaUserCog size={12} className="me-1" />
            {row.designation || 'No Role'}
          </small>
          {row.specialty && (
            <small className="text-info d-flex align-items-center mt-1">
              <FaCheckSquare size={12} className="me-1" />
              {row.specialty}
            </small>
          )}
        </div>
      ),
      sortable: true,
      width: "22%"
    },
    {
      name: 'Assigned Roles',
      cell: (row) => (
        <div>
          {row.roles && row.roles.length > 0 ? (
            <div className="d-flex flex-wrap gap-1">
              {row.roles.slice(0, 2).map((role, index) => (
                <span key={index} className="healthcare-status-badge healthcare-status-active" style={{
                  backgroundColor: '#dbeafe',
                  color: '#1e40af',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  {role.replace(/_/g, ' ')}
                </span>
              ))}
              {row.roles.length > 2 && (
                <span className="healthcare-status-badge" style={{
                  backgroundColor: '#f1f5f9',
                  color: '#64748b',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>
                  +{row.roles.length - 2} more
                </span>
              )}
            </div>
          ) : (
            <span className="healthcare-status-badge healthcare-status-inactive" style={{
              backgroundColor: '#fef3c7',
              color: '#92400e',
              padding: '2px 6px',
              borderRadius: '8px',
              fontSize: '0.75rem',
              fontWeight: '500'
            }}>
              No Roles
            </span>
          )}
          <div className="text-muted small mt-1" style={{ fontSize: '0.7rem' }}>
            {row.permissions_count || 0} permissions
          </div>
        </div>
      ),
      sortable: true,
      width: '20%',
    },
    {
      name: "Actions",
      cell: (row) => {
        const fullName = row.full_name || `${row.first_name || ''} ${row.last_name || ''}`.trim();
        return (
          <div className="d-flex gap-2">
            <Link to={`${config.baseUrl}edit-staff-duties/${row.id}`}>
              <button className="healthcare-action-btn healthcare-action-edit" style={{
                backgroundColor: '#2563eb',
                color: 'white',
                border: 'none',
                padding: '6px 12px',
                borderRadius: '6px',
                fontSize: '0.75rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <MdEdit size={12} />
                Assign Duty
              </button>
            </Link>

            <Link to={`${config.baseUrl}staff-duties/${row.id}`}>
              <button className="healthcare-action-btn healthcare-action-view" style={{
                backgroundColor: 'transparent',
                color: '#4b5563',
                border: '1px solid #d1d5db',
                padding: '6px 12px',
                borderRadius: '6px',
                fontSize: '0.75rem',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                gap: '4px'
              }}>
                <AiOutlineCalendar size={12} />
                View Calendar
              </button>
            </Link>
          </div>
        );
      },
      ignoreRowClick: true,
      width: "240px"
    },
  ];

  return (
    <>
      <div id="content" className="healthcare-container">
        <Container fluid className="p-4">
          {/* Header Section */}
          <Row className="mb-4">
            <Col lg={12}>
              <div style={{
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                padding: '20px'
              }}>
                <div className="d-flex align-items-center gap-3 mb-2">
                  <FaCalendarAlt size={24} style={{ color: '#4b5563' }} />
                  <h5 className="mb-0" style={{ color: '#1f2937', fontWeight: '600' }}>
                    Staff Duty Schedule
                  </h5>
                </div>
                <div className="subtitle" style={{ color: '#6b7280', fontSize: '0.875rem' }}>
                  Manage staff schedules, duties, and permissions
                </div>
                {hasFiltersApplied && (
                  <div className="d-flex justify-content-end mt-3">
                    <div className="d-flex align-items-center gap-2 px-3 py-1 rounded" style={{
                      backgroundColor: '#eff6ff',
                      color: '#2563eb',
                      fontSize: '0.75rem'
                    }}>
                      <BsInfoCircle size={16} />
                      <small>Filters applied</small>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          {/* Statistics Cards - Flat, Minimal Style */}
          <Row className="mb-4">
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded" style={{ backgroundColor: '#f1f5f9', border: '1px solid #e2e8f0' }}>
                <div className="me-3">
                  <FaUsers size={20} style={{ color: '#64748b' }} />
                </div>
                <div>
                  <div className="fw-bold fs-4 mb-0" style={{ color: '#1e293b' }}>{stats.total}</div>
                  <small className="text-muted">Total Staff</small>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded" style={{ backgroundColor: '#f0fdf4', border: '1px solid #d1fae5' }}>
                <div className="me-3">
                  <BsPersonCheck size={20} style={{ color: '#16a34a' }} />
                </div>
                <div>
                  <div className="fw-bold fs-4 mb-0" style={{ color: '#1e293b' }}>{stats.active}</div>
                  <small className="text-muted">Active</small>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded" style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe' }}>
                <div className="me-3">
                  <MdSchedule size={20} style={{ color: '#2563eb' }} />
                </div>
                <div>
                  <div className="fw-bold fs-4 mb-0" style={{ color: '#1e293b' }}>{stats.onDuty}</div>
                  <small className="text-muted">On Duty</small>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className="d-flex align-items-center p-3 rounded" style={{ backgroundColor: '#fef3c7', border: '1px solid #fde68a' }}>
                <div className="me-3">
                  <FaUserShield size={20} style={{ color: '#d97706' }} />
                </div>
                <div>
                  <div className="fw-bold fs-4 mb-0" style={{ color: '#1e293b' }}>{stats.withPermissions}</div>
                  <small className="text-muted">With Roles</small>
                </div>
              </div>
            </Col>
          </Row>

          {/* Filters and Search Section */}
          <div className="mb-4">
            <div className="d-flex align-items-center justify-content-between" style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              padding: '16px'
            }}>
              <div className="d-flex align-items-center gap-3">
                <div className="healthcare-search-container">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search staff by name or email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '0.875rem',
                      minWidth: '300px'
                    }}
                  />
                </div>
                <div>
                  <select
                    className="form-select"
                    value={filterBy}
                    onChange={(e) => setFilterBy(e.target.value)}
                    style={{
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      padding: '8px 12px',
                      fontSize: '0.875rem',
                      minWidth: '150px'
                    }}
                  >
                    <option value="all">All Staff</option>
                    <option value="active">Active Only</option>
                    <option value="inactive">Inactive Only</option>
                  </select>
                </div>
              </div>
              <div className="d-flex gap-2">
                <button
                  className={`btn ${showAdvancedFilters ? 'btn-primary' : 'btn-outline-secondary'} btn-sm`}
                  onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                  style={{ fontSize: '0.875rem' }}
                >
                  <MdFilterList size={16} className="me-1" />
                  Advanced Filters
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm"
                  onClick={resetAllFilters}
                  disabled={!hasFiltersApplied}
                  style={{ fontSize: '0.875rem' }}
                >
                  <MdRefresh size={16} className="me-1" />
                  Reset
                </button>
              </div>
            </div>

            {/* Advanced Filters */}
            {showAdvancedFilters && (
              <div className="mt-3 pt-3" style={{ borderTop: '1px solid #e2e8f0' }}>
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: '0.875rem', color: '#374151' }}>Staff Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Search by name..."
                        value={details.name}
                        onChange={searchByNameHandler}
                        style={{
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '0.875rem'
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: '0.875rem', color: '#374151' }}>From Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="fromDate"
                        value={details.fromDate}
                        onChange={searchByNameHandler}
                        style={{
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '0.875rem'
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label style={{ fontSize: '0.875rem', color: '#374151' }}>To Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="toDate"
                        value={details.toDate}
                        onChange={searchByNameHandler}
                        style={{
                          border: '1px solid #d1d5db',
                          borderRadius: '6px',
                          padding: '8px 12px',
                          fontSize: '0.875rem'
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3} className="d-flex align-items-end">
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={getStaffListAPI}
                      className="w-100"
                      style={{ fontSize: '0.875rem' }}
                    >
                      <FaSearch size={14} className="me-2" />
                      Apply Filters
                    </Button>
                  </Col>
                </Row>
              </div>
            )}
          </div>

          {/* Bulk Actions */}
          {showBulkActions && (
            <div className="mb-4" style={{
              backgroundColor: '#eff6ff',
              border: '1px solid #bfdbfe',
              borderRadius: '8px'
            }}>
              <div className="p-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-2" style={{ color: '#2563eb' }}>
                  <BsCheckSquare size={16} />
                  <strong>{selectedStaff.length}</strong> staff member(s) selected
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-primary btn-sm" style={{ fontSize: '0.75rem' }}>
                    <FaUserShield size={14} className="me-1" />
                    Bulk Assign Roles
                  </button>
                  <button className="btn btn-success btn-sm" style={{ fontSize: '0.75rem' }}>
                    <AiOutlineCalendar size={14} className="me-1" />
                    Bulk Schedule
                  </button>
                  <button className="btn btn-outline-secondary btn-sm" style={{ fontSize: '0.75rem' }}>
                    <BsPersonCheck size={14} className="me-1" />
                    Mark Active
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Main Data Table */}
          <div style={{
            backgroundColor: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '8px'
          }}>
            <div className="p-4">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="d-flex align-items-center gap-2">
                  <FaUsers size={18} style={{ color: '#4b5563' }} />
                  <h6 className="mb-0" style={{ color: '#1f2937', fontWeight: '600' }}>
                    Staff Members ({filteredStaffList.length})
                  </h6>
                </div>
                {selectedStaff.length > 0 && (
                  <div style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                    {selectedStaff.length} selected
                  </div>
                )}
              </div>

              {isLoading ? (
                <div className="healthcare-loading">
                  <div className="healthcare-loading-spinner"></div>
                  <div className="healthcare-loading-text">Loading staff list...</div>
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredStaffList}
                  pagination
                  paginationPerPage={rowsPerPage}
                  paginationRowsPerPageOptions={[10, 15, 25, 50, 100]}
                  paginationComponentOptions={{
                    rowsPerPageText: 'Rows per page:',
                    rangeSeparatorText: 'of',
                  }}
                  onChangePage={handlePageChange}
                  onChangeRowsPerPage={handleRowsPerPageChange}
                  highlightOnHover
                  striped
                  responsive
                  noDataComponent={
                    <div className="text-center py-5">
                      <BsPersonX size={48} className="text-muted mb-3" />
                      <p className="text-muted">No staff members found matching your criteria</p>
                      {hasFiltersApplied && (
                        <Button variant="outline-primary" size="sm" onClick={resetAllFilters}>
                          Clear Filters
                        </Button>
                      )}
                    </div>
                  }
                />
              )}
            </div>
          </div>
          {/*------------------------------- Section For Showing All Data For Print--------------------------------------------------- */}


          {/*------------------------------- Section For Showing Single Data For Print--------------------------------------------------- */}


          {/* Enhanced Permission Details Modal */}
          <Modal
            show={isModelView}
            onHide={handleViewClose}
            dialogClassName="modal-xl"
            aria-labelledby="permission-details-modal"
          >
            <Modal.Header closeButton className="border-0">
              <Modal.Title className="d-flex align-items-center gap-2">
                <FaUserShield style={{ color: 'var(--healthcare-primary)' }} />
                Permission Details - {currentStaffName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
              {formList.length > 0 ? (
                <>
                  {/* Summary Cards */}
                  <Row className="mb-4">
                    <Col md={4}>
                      <div className="healthcare-card text-center" style={{ background: 'linear-gradient(135deg, var(--healthcare-success) 0%, var(--healthcare-success-light) 100%)', color: 'white' }}>
                        <div className="p-3">
                          <h5 className="mb-1">
                            {formList.filter(data => data.isAccess === 1).length}
                          </h5>
                          <small>Access Permissions</small>
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="healthcare-card text-center" style={{ background: 'linear-gradient(135deg, var(--healthcare-warning) 0%, var(--healthcare-warning-light) 100%)', color: 'white' }}>
                        <div className="p-3">
                          <h5 className="mb-1">
                            {formList.filter(data => data.isEdit === 1).length}
                          </h5>
                          <small>Edit Permissions</small>
                        </div>
                      </div>
                    </Col>
                    <Col md={4}>
                      <div className="healthcare-card text-center" style={{ background: 'linear-gradient(135deg, var(--healthcare-danger) 0%, var(--healthcare-danger-light) 100%)', color: 'white' }}>
                        <div className="p-3">
                          <h5 className="mb-1">
                            {formList.filter(data => data.isDelete === 1).length}
                          </h5>
                          <small>Delete Permissions</small>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Permissions Table */}
                  <Table hover responsive>
                    <thead className="table-light">
                      <tr>
                        <th>Form Name</th>
                        <th>Department</th>
                        <th className="text-center">
                          <FaEye className="me-1" />
                          Access
                        </th>
                        <th className="text-center">
                          <MdEdit className="me-1" />
                          Edit
                        </th>
                        <th className="text-center">
                          <MdCancel className="me-1" />
                          Delete
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {formList
                        .filter(data => data.isAccess === 1 || data.isEdit === 1 || data.isDelete === 1)
                        .map((data) => (
                          <tr key={data.id}>
                            <td>
                              <strong>{data.name}</strong>
                            </td>
                            <td>
                              <span className="healthcare-status-badge healthcare-status-active">
                                {data.departmentName}
                              </span>
                            </td>
                            <td className="text-center">
                              {data.isAccess === 1 ? (
                                <span className="healthcare-status-badge healthcare-status-active">
                                  <FaCheck size={12} className="me-1" />
                                  Yes
                                </span>
                              ) : (
                                <span className="healthcare-status-badge healthcare-status-inactive">
                                  <FaTimes size={12} className="me-1" />
                                  No
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              {data.isEdit === 1 ? (
                                <span className="healthcare-status-badge healthcare-status-active">
                                  <FaCheck size={12} className="me-1" />
                                  Yes
                                </span>
                              ) : (
                                <span className="healthcare-status-badge healthcare-status-inactive">
                                  <FaTimes size={12} className="me-1" />
                                  No
                                </span>
                              )}
                            </td>
                            <td className="text-center">
                              {data.isDelete === 1 ? (
                                <span className="healthcare-status-badge healthcare-status-active">
                                  <FaCheck size={12} className="me-1" />
                                  Yes
                                </span>
                              ) : (
                                <span className="healthcare-status-badge healthcare-status-inactive">
                                  <FaTimes size={12} className="me-1" />
                                  No
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      }
                    </tbody>
                  </Table>

                  {formList.filter(data => data.isAccess === 1 || data.isEdit === 1 || data.isDelete === 1).length === 0 && (
                    <Alert variant="warning" className="text-center">
                      <BsInfoCircle className="me-2" />
                      No permissions assigned to this staff member
                    </Alert>
                  )}
                </>
              ) : (
                <div className="text-center py-5">
                  <Spinner animation="border" variant="primary" />
                  <p className="mt-3 text-muted">Loading permissions...</p>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer className="border-0">
              <div className="d-flex gap-2">
                <button
                  onClick={handleViewClose}
                  className="healthcare-btn healthcare-btn-secondary"
                >
                  Close
                </button>
                <button
                  onClick={() => {
                    handleViewClose();
                    handleOpen(staffId, currentStaffName);
                  }}
                  className="healthcare-btn healthcare-btn-primary"
                >
                  <BsGear size={14} />
                  Edit Permissions
                </button>
              </div>
            </Modal.Footer>
          </Modal>

          {/* Assign patient to staff */}

        </Container>
      </div>


      {/* Permission Configuration Modal Removed */}
      {/* Direct permission assignment has been removed to enforce RBAC principles */}
      {/* Users should only receive permissions through role assignments */}

      {/* Role Assignment Notice Modal */}
      <Modal
        show={isModelOpen}
        onHide={handleClose}
        dialogClassName="modal-lg"
        aria-labelledby="role-assignment-notice"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="d-flex align-items-center gap-2">
            <FaUserShield style={{ color: 'var(--healthcare-primary)' }} />
            Role-Based Access Control
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <div className="healthcare-card">
            <div className="p-4 text-center">
              <FaUserShield size={48} className="text-primary mb-3" />
              <h5 className="mb-3">Permission Management Updated</h5>
              <p className="text-muted mb-4">
                Direct permission assignment has been replaced with role-based access control.
                Users now receive permissions through role assignments only.
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button className="healthcare-btn healthcare-btn-primary" onClick={handleClose}>
                  <FaCheck className="me-2" />
                  Understood
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DutySchedule;
